import type { UserType } from 'store/users/types'

import { buildPath } from '@rentspree/path'

import {
  makeShowSweetAlert,
  showSweetAlert,
  RentSpeeSweetAlertOption,
} from 'components/common/organisms/sweetalert'
import env from 'env'

const goToMessagesModal = makeShowSweetAlert({
  ...RentSpeeSweetAlertOption,
  customClass: {
    cancelButton: 'rsp-swal-btn rsp-swal-cancel-btn',
    confirmButton: 'rsp-swal-btn rsp-swal-confirm-btn go-to-messages-btn',
    denyButton: 'rsp-swal-btn rsp-swal-deny-btn',
    container: 'rsp-swal-container go-to-messages-container',
  },
})

export const continueToMessage = (userType: UserType) => {
  if (window !== undefined) {
    let url = ''
    switch (userType) {
      case 'landlord':
        url = `${env.BASE_URL}/dashboard/v2/messaging`
        break
      case 'renter':
        url = `${env.BASE_URL}/dashboard/v2/public/messaging`
        break
      default:
        break
    }
    window.location.assign(url)
  }
}

export const openSweetAlertForLoggedIn = (userType: UserType, selectedDate: string[]): void => {
  void goToMessagesModal(
    {
      title: 'Tour requested',
      icon: 'success',
      showCancelButton: true,
      showCloseButton: true,
      html: `<h1 style="font-size: 16px;line-height: 28px;font-weight: 400;">Your preferred date(s):</h1>
      ${selectedDate
        .map((date) => `<p style="font-size: 16px;line-height: 28px;font-weight: 700;">${date}</p>`)
        .join('')}
      <p style="font-size: 16px;line-height: 28px;font-weight: 400;margin-top:25px;">
      You can chat with an agent via messages for more information.
      </p>`,
      confirmButtonText: 'Go to Messages',
      cancelButtonText: 'Back to Listing',
    },
    () => continueToMessage(userType),
  )
}

export const continueToSignUp = () => {
  window.location.assign(buildPath(`${env.BASE_URL}/account/signup`))
}

export const openSweetAlertForAnonymousUser = (selectedDate: string[]): void => {
  void showSweetAlert(
    {
      title: 'Tour requested',
      icon: 'success',
      html: `<h1 style="font-size: 16px;line-height: 28px;font-weight: 400;">Your preferred date(s):</h1>
      ${selectedDate
        .map((date) => `<p style="font-size: 16px;line-height: 28px;font-weight: 700;">${date}</p>`)
        .join('')}
      <p style="font-size: 16px;line-height: 28px;font-weight: 400;margin-top:25px;">
      Create a RentSpree account to streamline the rental process and never miss a message again.
      </p>`,
      showCloseButton: true,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sign Up',
      cancelButtonText: 'Back to Listing',
    },
    () => continueToSignUp(),
  )
}
